 <template>
    <paginate v-show="totalPage > 0"
         ref="customPagination"
        :page-count="totalPage"
        :callSetCurPage="callSetCurPage"
        :callSetRowsPerPage="callSetRowsPerPage"
        :cpCurrentPage=currentPage
        :cpRowsPerPage=rowsPerPage
    />
</template>

<script>
import Paginate from './customPagination';

export default {
    name: 'Pagination',
    components: {
        Paginate
    },
    props: {
        callSetCurPage: Function,
        callSetRowsPerPage: Function,
        totalPage: {
            type: Number,
            default: 1,
        },
        rowsPerPage: {
            type: Number,
            default: 10,
        },
        currentPage: {
            type: Number,
            default: 1,
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue